export const AccessMode = {
  FULL: 'FULL',
  READ_ONLY: 'READ_ONLY',
} as const;
export type AccessMode = (typeof AccessMode)[keyof typeof AccessMode];

export const AccountClaimStatus = {
  AVAILABLE: 'AVAILABLE',
  IN_CLIENT: 'IN_CLIENT',
  UNAVAILABLE: 'UNAVAILABLE',
  REQUESTABLE: 'REQUESTABLE',
  REQUESTED: 'REQUESTED',
} as const;
export type AccountClaimStatus =
  (typeof AccountClaimStatus)[keyof typeof AccountClaimStatus];

export const AccountHealthStatus = {
  CRITICAL: 'critical',
  DEGRADED: 'degraded',
  UNVERIFIED: 'unverified',
  HEALTHY: 'healthy',
} as const;
export type AccountHealthStatus =
  (typeof AccountHealthStatus)[keyof typeof AccountHealthStatus];

export const AdFormat = {
  SINGLE_IMAGE_OR_VIDEO: 'single_image_or_video',
  CAROUSEL: 'carousel',
  COLLECTION: 'collection',
} as const;
export type AdFormat = (typeof AdFormat)[keyof typeof AdFormat];

export const AdminAuditEntityType = {
  STRATEGY: 'strategy',
  STRATEGY_CAMPAIGN: 'strategy_campaign',
  ORGANIZATION: 'organization',
  USER: 'user',
  INVITATION: 'invitation',
  PLATFORM_CONNECTION: 'platform_connection',
  ORGANIZATION_DOMAIN: 'organization_domain',
  BACKGROUND_JOB: 'background_job',
  ORGANIZATION_BILLING: 'organization_billing',
  CREDIT_LEDGER: 'credit_ledger',
} as const;
export type AdminAuditEntityType =
  (typeof AdminAuditEntityType)[keyof typeof AdminAuditEntityType];

export const AdminBillingMutation = {
  SET_PLAN: 'SET_PLAN',
  EXTEND_TRIAL: 'EXTEND_TRIAL',
} as const;
export type AdminBillingMutation =
  (typeof AdminBillingMutation)[keyof typeof AdminBillingMutation];

export const AgeRangeType = {
  AGE_18_24: '18-24',
  AGE_25_34: '25-34',
  AGE_35_44: '35-44',
  AGE_45_54: '45-54',
  AGE_55_64: '55-64',
  AGE_65_PLUS: '65+',
} as const;
export type AgeRangeType = (typeof AgeRangeType)[keyof typeof AgeRangeType];

export const AgencyAssignmentSource = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
} as const;
export type AgencyAssignmentSource =
  (typeof AgencyAssignmentSource)[keyof typeof AgencyAssignmentSource];

export const AgencyOnboardingOutcome = {
  CREATED: 'CREATED',
  ATTACHED: 'ATTACHED',
  UNCHANGED: 'UNCHANGED',
  REFUSED: 'REFUSED',
} as const;
export type AgencyOnboardingOutcome =
  (typeof AgencyOnboardingOutcome)[keyof typeof AgencyOnboardingOutcome];

export const AllocationReasonCode = {
  SEARCH_AD_GROUPS_CAPPED: 'SEARCH_AD_GROUPS_CAPPED',
  SEARCH_CAPPED_AT_CEILING: 'SEARCH_CAPPED_AT_CEILING',
  CHANNEL_DROPPED_BELOW_FLOOR: 'CHANNEL_DROPPED_BELOW_FLOOR',
  OFFERS_UNFUNDED: 'OFFERS_UNFUNDED',
  BUDGET_SURPLUS: 'BUDGET_SURPLUS',
  ROUNDING_REMAINDER: 'ROUNDING_REMAINDER',
} as const;
export type AllocationReasonCode =
  (typeof AllocationReasonCode)[keyof typeof AllocationReasonCode];

export const AllocatorChannel = {
  GOOGLE_SEARCH: 'GOOGLE_SEARCH',
  GOOGLE_PMAX: 'GOOGLE_PMAX',
  META_LEADS: 'META_LEADS',
} as const;
export type AllocatorChannel =
  (typeof AllocatorChannel)[keyof typeof AllocatorChannel];

export const AmazonCampaignType = {
  SPONSORED_PRODUCTS: 'SPONSORED_PRODUCTS',
  SPONSORED_BRANDS: 'SPONSORED_BRANDS',
  SPONSORED_DISPLAY: 'SPONSORED_DISPLAY',
} as const;
export type AmazonCampaignType =
  (typeof AmazonCampaignType)[keyof typeof AmazonCampaignType];

export const AssetPlacement = {
  SQUARE: 'square',
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
  STORY: 'story',
} as const;
export type AssetPlacement =
  (typeof AssetPlacement)[keyof typeof AssetPlacement];

export const AssetSource = {
  SYNCED: 'synced',
  SCRAPED: 'scraped',
  UPLOADED: 'uploaded',
  GENERATED: 'generated',
} as const;
export type AssetSource = (typeof AssetSource)[keyof typeof AssetSource];

export const AudienceSignalType = {
  INTEREST: 'interest',
  IN_MARKET: 'in_market',
  AFFINITY: 'affinity',
  DETAILED_TARGETING: 'detailed_targeting',
  PIXEL_EVENT: 'pixel_event',
  URL_PATTERN: 'url_pattern',
} as const;
export type AudienceSignalType =
  (typeof AudienceSignalType)[keyof typeof AudienceSignalType];

export const AudienceSizeBasis = {
  MEMBERSHIP: 'membership',
  REACH: 'reach',
} as const;
export type AudienceSizeBasis =
  (typeof AudienceSizeBasis)[keyof typeof AudienceSizeBasis];

export const AudienceSizeState = {
  REPORTED: 'reported',
  PENDING: 'pending',
  UNAVAILABLE: 'unavailable',
} as const;
export type AudienceSizeState =
  (typeof AudienceSizeState)[keyof typeof AudienceSizeState];

export const AudienceSource = {
  IMPORTED: 'imported',
  UPLOADED: 'uploaded',
  LOOKALIKE: 'lookalike',
  INTEREST_SEGMENT: 'interest_segment',
  IN_MARKET: 'in_market',
  REMARKETING: 'remarketing',
  RULE_BASED: 'rule_based',
} as const;
export type AudienceSource =
  (typeof AudienceSource)[keyof typeof AudienceSource];

export const AudienceStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETED: 'deleted',
  PENDING_UPLOAD: 'pending_upload',
  UPLOAD_FAILED: 'upload_failed',
} as const;
export type AudienceStatus =
  (typeof AudienceStatus)[keyof typeof AudienceStatus];

export const AudienceSyncPolicy = {
  LINKED_EXISTING: 'linked_existing',
  DUAL_PUBLISH: 'dual_publish',
  SINGLE_PLATFORM: 'single_platform',
} as const;
export type AudienceSyncPolicy =
  (typeof AudienceSyncPolicy)[keyof typeof AudienceSyncPolicy];

export const AudienceType = {
  CUSTOM: 'custom',
  CRM_BASED: 'crm_based',
  RULE_BASED: 'rule_based',
  LOOKALIKE: 'lookalike',
  SAVED: 'saved',
  IN_MARKET: 'in_market',
  AFFINITY: 'affinity',
} as const;
export type AudienceType = (typeof AudienceType)[keyof typeof AudienceType];

export const AuditAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;
export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export const AuditChangeSource = {
  MANUAL: 'manual',
  SYSTEM_SYNC: 'system_sync',
  EXTERNAL_DETECTED: 'external_detected',
  EXTERNAL_ACCEPTED: 'external_accepted',
  COPILOT_COMMAND: 'copilot_command',
  COPILOT_WIZARD: 'copilot_wizard',
  DIRECT_EDIT: 'direct_edit',
  PUSH_ROLLBACK: 'push_rollback',
} as const;
export type AuditChangeSource =
  (typeof AuditChangeSource)[keyof typeof AuditChangeSource];

export const AuditEntityType = {
  STRATEGY: 'strategy',
  CAMPAIGN: 'campaign',
} as const;
export type AuditEntityType =
  (typeof AuditEntityType)[keyof typeof AuditEntityType];

export const AuditExportSource = {
  FORM: 'form',
  EMAIL: 'email',
} as const;
export type AuditExportSource =
  (typeof AuditExportSource)[keyof typeof AuditExportSource];

export const AuditExportUploadStatus = {
  RECEIVED: 'received',
  EXPIRED: 'expired',
} as const;
export type AuditExportUploadStatus =
  (typeof AuditExportUploadStatus)[keyof typeof AuditExportUploadStatus];

export const AuditReportIntakeStatus = {
  RECEIVED: 'received',
  HALTED: 'halted',
  READY: 'ready',
} as const;
export type AuditReportIntakeStatus =
  (typeof AuditReportIntakeStatus)[keyof typeof AuditReportIntakeStatus];

export const AuditReportReviewStatus = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;
export type AuditReportReviewStatus =
  (typeof AuditReportReviewStatus)[keyof typeof AuditReportReviewStatus];

export const BackgroundJobOutcome = {
  NORMAL: 'NORMAL',
  ZERO_RESULT: 'ZERO_RESULT',
} as const;
export type BackgroundJobOutcome =
  (typeof BackgroundJobOutcome)[keyof typeof BackgroundJobOutcome];

export const BackgroundJobStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
export type BackgroundJobStatus =
  (typeof BackgroundJobStatus)[keyof typeof BackgroundJobStatus];

export const BackgroundJobType = {
  PRODUCT_CATEGORY_SYNC: 'product_category_sync',
  GOOGLE_CALLOUT_SYNC: 'google_callout_sync',
  GOOGLE_SITELINK_SYNC: 'google_sitelink_sync',
  GOOGLE_CREATIVE_ASSET_SYNC: 'google_creative_asset_sync',
  META_CREATIVE_ASSET_SYNC: 'meta_creative_asset_sync',
  SITELINK_SCRAPE: 'sitelink_scrape',
  METRIC_SYNC: 'metric_sync',
  MEASUREMENT_SYNC: 'measurement_sync',
  MEDIA_PLAN_GENERATION: 'media_plan_generation',
  WIZARD_CAMPAIGNS: 'wizard_campaigns',
  WIZARD_PUSH: 'wizard_push',
  CAMPAIGN_IMPORT: 'campaign_import',
  FULL_CONFIG_IMPORT: 'full_config_import',
  CAMPAIGN_REFRESH: 'campaign_refresh',
  BACKFILL_METRICS: 'backfill_metrics',
  BACKFILL_CONVERSION_GOALS: 'backfill_conversion_goals',
  EXTRACT_ASSET_METADATA: 'extract_asset_metadata',
  SYNC_ASSET_TO_GOOGLE: 'sync_asset_to_google',
  SYNC_ASSET_TO_META: 'sync_asset_to_meta',
  CAMPAIGN_DETAILS_SYNC: 'campaign_details_sync',
  RECOMMENDATIONS_ANALYSIS: 'recommendations_analysis',
  CONNECTION_REINGESTION: 'connection_reingestion',
  COPILOT_COMMAND_PUSH: 'copilot_command_push',
  DIRECT_EDIT_PUSH: 'direct_edit_push',
  GOAL_UPDATE_PUSH: 'goal_update_push',
  STRATEGY_STATUS_PUSH: 'strategy_status_push',
  DEMO_RESET: 'demo_reset',
  GOOGLE_CONVERSION_ACTION_IMPORT: 'google_conversion_action_import',
  META_CONVERSION_IMPORT: 'meta_conversion_import',
  GOOGLE_AUDIENCE_SYNC: 'google_audience_sync',
  META_AUDIENCE_SYNC: 'meta_audience_sync',
  CUSTOMER_LIST_PUBLISH: 'customer_list_publish',
  RESCORE_MIXED_BASIS_OUTCOMES: 'rescore_mixed_basis_outcomes',
  CONVERSION_FORWARD: 'conversion_forward',
  PUSH_SUPPORT_REQUEST: 'push_support_request',
  AGENCY_ONBOARDING: 'agency_onboarding',
  MEDIA_PLAN_PDF: 'media_plan_pdf',
  GENERATE_AD_IMAGE: 'generate_ad_image',
  COMPOSE_AD_IMAGE: 'compose_ad_image',
} as const;
export type BackgroundJobType =
  (typeof BackgroundJobType)[keyof typeof BackgroundJobType];

export const BidStrategy = {
  MANUAL: 'MANUAL',
  BID_CAP: 'BID_CAP',
  MAXIMIZE_CLICKS: 'MAXIMIZE_CLICKS',
  MAXIMIZE_CONVERSIONS: 'MAXIMIZE_CONVERSIONS',
  MAXIMIZE_CONVERSION_VALUE: 'MAXIMIZE_CONVERSION_VALUE',
  TARGET_CPA: 'TARGET_CPA',
  TARGET_ROAS: 'TARGET_ROAS',
} as const;
export type BidStrategy = (typeof BidStrategy)[keyof typeof BidStrategy];

export const BillingInterval = {
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL',
} as const;
export type BillingInterval =
  (typeof BillingInterval)[keyof typeof BillingInterval];

export const BriefWarningCode = {
  OFFER_URL_DOMAIN_MISMATCH: 'OFFER_URL_DOMAIN_MISMATCH',
} as const;
export type BriefWarningCode =
  (typeof BriefWarningCode)[keyof typeof BriefWarningCode];

export const BudgetChangeType = {
  SET: 'SET',
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
  PERCENTAGE_INCREASE: 'PERCENTAGE_INCREASE',
  PERCENTAGE_DECREASE: 'PERCENTAGE_DECREASE',
} as const;
export type BudgetChangeType =
  (typeof BudgetChangeType)[keyof typeof BudgetChangeType];

export const BudgetLevel = {
  CAMPAIGN: 'campaign',
  AD_SET: 'ad_set',
} as const;
export type BudgetLevel = (typeof BudgetLevel)[keyof typeof BudgetLevel];

export const BusinessModel = {
  COMMERCE: 'COMMERCE',
  LEAD_GEN: 'LEAD_GEN',
} as const;
export type BusinessModel = (typeof BusinessModel)[keyof typeof BusinessModel];

export const BusinessModelSource = {
  DETECTED: 'DETECTED',
  USER: 'USER',
} as const;
export type BusinessModelSource =
  (typeof BusinessModelSource)[keyof typeof BusinessModelSource];

export const CallToAction = {
  SHOP_NOW: 'shop_now',
  LEARN_MORE: 'learn_more',
  SIGN_UP: 'sign_up',
  BOOK_NOW: 'book_now',
  GET_OFFER: 'get_offer',
  DOWNLOAD: 'download',
  CONTACT_US: 'contact_us',
  APPLY_NOW: 'apply_now',
  GET_QUOTE: 'get_quote',
  SUBSCRIBE: 'subscribe',
  CALL_NOW: 'call_now',
} as const;
export type CallToAction = (typeof CallToAction)[keyof typeof CallToAction];

export const CampaignContentField = {
  HEADLINES: 'headlines',
  DESCRIPTIONS: 'descriptions',
  FINAL_URL: 'final_url',
  KEYWORDS: 'keywords',
  NEGATIVE_KEYWORDS: 'negative_keywords',
  TARGETING: 'targeting',
  EXTENSIONS: 'extensions',
  BIDDING: 'bidding',
  SHOPPING_SETTINGS: 'shopping_settings',
  PRODUCT_FILTERS: 'product_filters',
  PRODUCT_GROUPS: 'product_groups',
  CALL_TO_ACTION: 'call_to_action',
  AD_FORMAT: 'ad_format',
} as const;
export type CampaignContentField =
  (typeof CampaignContentField)[keyof typeof CampaignContentField];

export const CampaignIntent = {
  AWARENESS: 'AWARENESS',
  TRAFFIC: 'TRAFFIC',
  ENGAGEMENT: 'ENGAGEMENT',
  LEADS: 'LEADS',
  SALES: 'SALES',
} as const;
export type CampaignIntent =
  (typeof CampaignIntent)[keyof typeof CampaignIntent];

export const CampaignLaunchMode = {
  LIVE: 'LIVE',
  PAUSED_FOR_REVIEW: 'PAUSED_FOR_REVIEW',
} as const;
export type CampaignLaunchMode =
  (typeof CampaignLaunchMode)[keyof typeof CampaignLaunchMode];

export const CampaignMutationField = {
  BUDGET: 'budget',
  STATUS: 'status',
  CONTENT: 'content',
  CONVERSION_GOAL: 'conversion_goal',
  ENTITY_STATUS: 'entity_status',
} as const;
export type CampaignMutationField =
  (typeof CampaignMutationField)[keyof typeof CampaignMutationField];

export const CampaignOrigin = {
  WIZARD: 'wizard',
  IMPORTED: 'imported',
} as const;
export type CampaignOrigin =
  (typeof CampaignOrigin)[keyof typeof CampaignOrigin];

export const CampaignStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  DELETED: 'DELETED',
} as const;
export type CampaignStatus =
  (typeof CampaignStatus)[keyof typeof CampaignStatus];

export const CategorySuggestionSource = {
  RECENT_STRATEGIES: 'recent_strategies',
  SUGGESTED_LANDING_URL: 'suggested_landing_url',
} as const;
export type CategorySuggestionSource =
  (typeof CategorySuggestionSource)[keyof typeof CategorySuggestionSource];

export const ClaimVerdict = {
  YIELD: 'YIELD',
  MANAGEMENT_REQUEST: 'MANAGEMENT_REQUEST',
  HELD_ELSEWHERE: 'HELD_ELSEWHERE',
  HELD_BY_AGENCY: 'HELD_BY_AGENCY',
  HELD_BY_SIBLING_CLIENT: 'HELD_BY_SIBLING_CLIENT',
} as const;
export type ClaimVerdict = (typeof ClaimVerdict)[keyof typeof ClaimVerdict];

export const ClaimWindow = {
  PLATFORM_DEFAULT: 'platform_default',
  CLICK_1D: '1d_click',
  CLICK_7D: '7d_click',
  CLICK_28D: '28d_click',
} as const;
export type ClaimWindow = (typeof ClaimWindow)[keyof typeof ClaimWindow];

export const ClaimedAsset = {
  AD_ACCOUNT: 'ad_account',
  FACEBOOK_PAGE: 'facebook_page',
} as const;
export type ClaimedAsset = (typeof ClaimedAsset)[keyof typeof ClaimedAsset];

export const ContentPushMethod = {
  AD_ASSETS: 'ad_assets',
  KEYWORDS: 'keywords',
  TARGETING: 'targeting',
  EXTENSIONS: 'extensions',
  BIDDING: 'bidding',
  SHOPPING_SETTINGS: 'shopping_settings',
  PRODUCT_FILTERS: 'product_filters',
  PRODUCT_GROUPS: 'product_groups',
} as const;
export type ContentPushMethod =
  (typeof ContentPushMethod)[keyof typeof ContentPushMethod];

export const ConversionGoalMode = {
  ACCOUNT_DEFAULT: 'account_default',
  CUSTOM: 'custom',
} as const;
export type ConversionGoalMode =
  (typeof ConversionGoalMode)[keyof typeof ConversionGoalMode];

export const CostPerConversionMetric = {
  LEAD: 'lead',
  BOOKING: 'booking',
  CALL: 'call',
} as const;
export type CostPerConversionMetric =
  (typeof CostPerConversionMetric)[keyof typeof CostPerConversionMetric];

export const CountingStatus = {
  COUNTED: 'counted',
  BEING_READ: 'being_read',
  NOT_AVAILABLE: 'not_available',
  NO_ACTIVITY: 'no_activity',
} as const;
export type CountingStatus =
  (typeof CountingStatus)[keyof typeof CountingStatus];

export const CreateStrategyWizardStep = {
  MEDIA_PLAN_GENERATED: 'media_plan_generated',
  CAMPAIGNS_GENERATED: 'campaigns_generated',
} as const;
export type CreateStrategyWizardStep =
  (typeof CreateStrategyWizardStep)[keyof typeof CreateStrategyWizardStep];

export const CreativeAssetKind = {
  BUSINESS_NAME: 'business_name',
  LOGO: 'logo',
  MARKETING_IMAGE: 'marketing_image',
  SQUARE_MARKETING_IMAGE: 'square_marketing_image',
  IMAGE: 'image',
  VIDEO: 'video',
} as const;
export type CreativeAssetKind =
  (typeof CreativeAssetKind)[keyof typeof CreativeAssetKind];

export const CreativeAssetStatus = {
  PENDING_METADATA: 'pending_metadata',
  ACTIVE: 'active',
  INVALID: 'invalid',
  ARCHIVED: 'archived',
} as const;
export type CreativeAssetStatus =
  (typeof CreativeAssetStatus)[keyof typeof CreativeAssetStatus];

export const CreativeOption = {
  SINGLE_IMAGE: 'single_image',
  SLIDESHOW: 'slideshow',
} as const;
export type CreativeOption =
  (typeof CreativeOption)[keyof typeof CreativeOption];

export const CreditAction = {
  COPILOT_MESSAGE: 'COPILOT_MESSAGE',
  MEDIA_PLAN_GENERATION: 'MEDIA_PLAN_GENERATION',
  CAMPAIGN_BUILD: 'CAMPAIGN_BUILD',
  CREATIVE_TEXT: 'CREATIVE_TEXT',
  FORECAST_GENERATION: 'FORECAST_GENERATION',
  IMAGE_GENERATION: 'IMAGE_GENERATION',
} as const;
export type CreditAction = (typeof CreditAction)[keyof typeof CreditAction];

export const CreditBucket = {
  MONTHLY: 'MONTHLY',
  PURCHASED: 'PURCHASED',
} as const;
export type CreditBucket = (typeof CreditBucket)[keyof typeof CreditBucket];

export const CreditEntryKind = {
  GRANT_TRIAL: 'GRANT_TRIAL',
  GRANT_MONTHLY: 'GRANT_MONTHLY',
  GRANT_PURCHASED: 'GRANT_PURCHASED',
  GRANT_MANUAL: 'GRANT_MANUAL',
  RESERVE: 'RESERVE',
  SETTLE: 'SETTLE',
  RELEASE: 'RELEASE',
  CONSUME: 'CONSUME',
  OVERAGE: 'OVERAGE',
  EXPIRE: 'EXPIRE',
  REVOKE: 'REVOKE',
} as const;
export type CreditEntryKind =
  (typeof CreditEntryKind)[keyof typeof CreditEntryKind];

export const CreditReferenceType = {
  THREAD_MESSAGE: 'THREAD_MESSAGE',
  MEDIA_PLAN: 'MEDIA_PLAN',
  STRATEGY_CAMPAIGN: 'STRATEGY_CAMPAIGN',
  STRIPE_INVOICE: 'STRIPE_INVOICE',
  TOP_UP_PACK: 'TOP_UP_PACK',
  MANUAL_GRANT: 'MANUAL_GRANT',
  BILLING_PERIOD: 'BILLING_PERIOD',
  BACKGROUND_JOB: 'BACKGROUND_JOB',
  ORGANIZATION: 'ORGANIZATION',
  AGENCY_ATTACH: 'AGENCY_ATTACH',
  AGENCY_DISSOLVE: 'AGENCY_DISSOLVE',
} as const;
export type CreditReferenceType =
  (typeof CreditReferenceType)[keyof typeof CreditReferenceType];

export const CustomSegmentType = {
  PEOPLE_WHO_SEARCHED_FOR: 'people_who_searched_for',
  PEOPLE_WITH_ANY_OF_INTERESTS: 'people_with_any_of_interests',
  PEOPLE_WHO_BROWSED_FOR: 'people_who_browsed_for',
} as const;
export type CustomSegmentType =
  (typeof CustomSegmentType)[keyof typeof CustomSegmentType];

export const CustomerAcquisitionMode = {
  TARGET_ALL_EQUALLY: 'target_all_equally',
  BID_HIGHER_FOR_NEW: 'bid_higher_for_new',
  TARGET_NEW_ONLY: 'target_new_only',
} as const;
export type CustomerAcquisitionMode =
  (typeof CustomerAcquisitionMode)[keyof typeof CustomerAcquisitionMode];

export const CustomerListColumn = {
  EMAIL: 'email',
  PHONE: 'phone',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  COUNTRY: 'country',
} as const;
export type CustomerListColumn =
  (typeof CustomerListColumn)[keyof typeof CustomerListColumn];

export const CustomerListJobState = {
  PENDING: 'pending',
  APPLIED: 'applied',
  REJECTED: 'rejected',
} as const;
export type CustomerListJobState =
  (typeof CustomerListJobState)[keyof typeof CustomerListJobState];

export const CustomerListStagingStatus = {
  STAGED: 'staged',
  CONSUMED: 'consumed',
  EXPIRED: 'expired',
} as const;
export type CustomerListStagingStatus =
  (typeof CustomerListStagingStatus)[keyof typeof CustomerListStagingStatus];

export const DateRangeEnum = {
  LAST_7D: 'LAST_7D',
  LAST_14D: 'LAST_14D',
  LAST_30D: 'LAST_30D',
  LAST_90D: 'LAST_90D',
  CUSTOM: 'CUSTOM',
} as const;
export type DateRangeEnum = (typeof DateRangeEnum)[keyof typeof DateRangeEnum];

export const DayOfWeek = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
} as const;
export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

export const DeliveryControlKind = {
  WINDOW: 'WINDOW',
  SCHEDULE: 'SCHEDULE',
  FREQUENCY_CAP: 'FREQUENCY_CAP',
  PACING: 'PACING',
} as const;
export type DeliveryControlKind =
  (typeof DeliveryControlKind)[keyof typeof DeliveryControlKind];

export const DimensionId = {
  PLATFORM: 'platform',
  STRATEGY: 'strategy',
  CAMPAIGN: 'campaign',
  CAMPAIGN_TYPE: 'campaign_type',
  CAMPAIGN_STATUS: 'campaign_status',
  DEVICE: 'device',
  GEO: 'geo',
  AGE: 'age',
  GENDER: 'gender',
  PLACEMENT: 'placement',
  HOUR: 'hour',
  SEARCH_TERM: 'search_term',
  KEYWORD: 'keyword',
  AD_GROUP: 'ad_group',
  AD: 'ad',
} as const;
export type DimensionId = (typeof DimensionId)[keyof typeof DimensionId];

export const DisplayCallToAction = {
  LEARN_MORE: 'learn_more',
  SHOP_NOW: 'shop_now',
  SIGN_UP: 'sign_up',
  GET_STARTED: 'get_started',
  BOOK_NOW: 'book_now',
  CONTACT_US: 'contact_us',
  SUBSCRIBE: 'subscribe',
  DOWNLOAD: 'download',
  GET_OFFER: 'get_offer',
  APPLY_NOW: 'apply_now',
} as const;
export type DisplayCallToAction =
  (typeof DisplayCallToAction)[keyof typeof DisplayCallToAction];

export const DisplayExclusionType = {
  PLACEMENT: 'PLACEMENT',
  CONTENT_LABEL: 'CONTENT_LABEL',
  TOPIC: 'TOPIC',
} as const;
export type DisplayExclusionType =
  (typeof DisplayExclusionType)[keyof typeof DisplayExclusionType];

export const DisplayFrequencyCapTimeUnit = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
} as const;
export type DisplayFrequencyCapTimeUnit =
  (typeof DisplayFrequencyCapTimeUnit)[keyof typeof DisplayFrequencyCapTimeUnit];

export const DisplayTargetingType = {
  IN_MARKET: 'IN_MARKET',
  CUSTOM_INTENT: 'CUSTOM_INTENT',
  SIMILAR_AUDIENCE: 'SIMILAR_AUDIENCE',
  REMARKETING: 'REMARKETING',
  TOPIC: 'TOPIC',
  PLACEMENT: 'PLACEMENT',
} as const;
export type DisplayTargetingType =
  (typeof DisplayTargetingType)[keyof typeof DisplayTargetingType];

export const Environment = {
  LOCAL: 'local',
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
} as const;
export type Environment = (typeof Environment)[keyof typeof Environment];

export const EvalFeature = {
  GENERATION: 'generation',
  COPILOT: 'copilot',
  RECOMMENDATIONS: 'recommendations',
  INSIGHTS: 'insights',
} as const;
export type EvalFeature = (typeof EvalFeature)[keyof typeof EvalFeature];

export const ExtensionBucket = {
  CALLOUTS: 'callouts',
  SITELINKS: 'sitelinks',
  STRUCTURED_SNIPPETS: 'structured_snippets',
} as const;
export type ExtensionBucket =
  (typeof ExtensionBucket)[keyof typeof ExtensionBucket];

export const FieldAvailability = {
  AVAILABLE: 'available',
  AWAITING_INGESTION: 'awaiting_ingestion',
} as const;
export type FieldAvailability =
  (typeof FieldAvailability)[keyof typeof FieldAvailability];

export const FieldSubstrate = {
  CAMPAIGN_METRIC: 'campaign_metric',
  PLATFORM_REPORT_METRIC: 'platform_report_metric',
} as const;
export type FieldSubstrate =
  (typeof FieldSubstrate)[keyof typeof FieldSubstrate];

export const FieldValueType = {
  ID: 'id',
  ENUM: 'enum',
  STRING: 'string',
} as const;
export type FieldValueType =
  (typeof FieldValueType)[keyof typeof FieldValueType];

export const FilterOperator = {
  EQ: 'eq',
  NE: 'ne',
  IN: 'in',
  NOT_IN: 'not_in',
  CONTAINS: 'contains',
} as const;
export type FilterOperator =
  (typeof FilterOperator)[keyof typeof FilterOperator];

export const GA4CountingMethod = {
  ONCE_PER_EVENT: 'ONCE_PER_EVENT',
  ONCE_PER_SESSION: 'ONCE_PER_SESSION',
} as const;
export type GA4CountingMethod =
  (typeof GA4CountingMethod)[keyof typeof GA4CountingMethod];

export const GA4EventComparisonType = {
  EQUALS: 'EQUALS',
  EQUALS_CASE_INSENSITIVE: 'EQUALS_CASE_INSENSITIVE',
  CONTAINS: 'CONTAINS',
  CONTAINS_CASE_INSENSITIVE: 'CONTAINS_CASE_INSENSITIVE',
  STARTS_WITH: 'STARTS_WITH',
  STARTS_WITH_CASE_INSENSITIVE: 'STARTS_WITH_CASE_INSENSITIVE',
  ENDS_WITH: 'ENDS_WITH',
  ENDS_WITH_CASE_INSENSITIVE: 'ENDS_WITH_CASE_INSENSITIVE',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  REGULAR_EXPRESSION: 'REGULAR_EXPRESSION',
  REGULAR_EXPRESSION_CASE_INSENSITIVE: 'REGULAR_EXPRESSION_CASE_INSENSITIVE',
  UNKNOWN: 'UNKNOWN',
} as const;
export type GA4EventComparisonType =
  (typeof GA4EventComparisonType)[keyof typeof GA4EventComparisonType];

export const GenderType = {
  MALE: 'male',
  FEMALE: 'female',
  ALL: 'all',
} as const;
export type GenderType = (typeof GenderType)[keyof typeof GenderType];

export const GeneratedProductGroupDimension = {
  BRAND: 'brand',
  PRODUCT_TYPE: 'product_type',
  ITEM_ID: 'item_id',
  CUSTOM_LABEL_0: 'custom_label_0',
} as const;
export type GeneratedProductGroupDimension =
  (typeof GeneratedProductGroupDimension)[keyof typeof GeneratedProductGroupDimension];

export const GoogleAdType = {
  RESPONSIVE_SEARCH_AD: 'RESPONSIVE_SEARCH_AD',
  RESPONSIVE_DISPLAY_AD: 'RESPONSIVE_DISPLAY_AD',
  EXPANDED_TEXT_AD: 'EXPANDED_TEXT_AD',
  TEXT_AD: 'TEXT_AD',
  EXPANDED_DYNAMIC_SEARCH_AD: 'EXPANDED_DYNAMIC_SEARCH_AD',
  CALL_AD: 'CALL_AD',
  IMAGE_AD: 'IMAGE_AD',
  LEGACY_RESPONSIVE_DISPLAY_AD: 'LEGACY_RESPONSIVE_DISPLAY_AD',
  HTML5_UPLOAD_AD: 'HTML5_UPLOAD_AD',
  SHOPPING_PRODUCT_AD: 'SHOPPING_PRODUCT_AD',
  OTHER: 'OTHER',
} as const;
export type GoogleAdType = (typeof GoogleAdType)[keyof typeof GoogleAdType];

export const GoogleCampaignType = {
  SEARCH: 'SEARCH',
  PERFORMANCE_MAX: 'PERFORMANCE_MAX',
  DISPLAY: 'DISPLAY',
  SHOPPING: 'STANDARD_SHOPPING',
} as const;
export type GoogleCampaignType =
  (typeof GoogleCampaignType)[keyof typeof GoogleCampaignType];

export const GoogleDisplayBiddingStrategy = {
  MAXIMIZE_CLICKS: 'MAXIMIZE_CLICKS',
  MAXIMIZE_CONVERSIONS: 'MAXIMIZE_CONVERSIONS',
  MAXIMIZE_CONVERSION_VALUE: 'MAXIMIZE_CONVERSION_VALUE',
  TARGET_CPA: 'TARGET_CPA',
  TARGET_ROAS: 'TARGET_ROAS',
  MANUAL_CPC: 'MANUAL_CPC',
} as const;
export type GoogleDisplayBiddingStrategy =
  (typeof GoogleDisplayBiddingStrategy)[keyof typeof GoogleDisplayBiddingStrategy];

export const GoogleResourceKind = {
  USER_LIST: 'user_list',
  CUSTOM_AUDIENCE: 'custom_audience',
  USER_INTEREST: 'user_interest',
  TOPIC: 'topic',
  AUDIENCE: 'audience',
} as const;
export type GoogleResourceKind =
  (typeof GoogleResourceKind)[keyof typeof GoogleResourceKind];

export const GoogleSearchBiddingStrategy = {
  MAXIMIZE_CLICKS: 'MAXIMIZE_CLICKS',
  MAXIMIZE_CONVERSIONS: 'MAXIMIZE_CONVERSIONS',
  MAXIMIZE_CONVERSION_VALUE: 'MAXIMIZE_CONVERSION_VALUE',
  TARGET_CPA: 'TARGET_CPA',
  TARGET_ROAS: 'TARGET_ROAS',
} as const;
export type GoogleSearchBiddingStrategy =
  (typeof GoogleSearchBiddingStrategy)[keyof typeof GoogleSearchBiddingStrategy];

export const GoogleShoppingBiddingStrategy = {
  MANUAL_CPC: 'MANUAL_CPC',
  TARGET_ROAS: 'TARGET_ROAS',
  MAXIMIZE_CONVERSION_VALUE: 'MAXIMIZE_CONVERSION_VALUE',
} as const;
export type GoogleShoppingBiddingStrategy =
  (typeof GoogleShoppingBiddingStrategy)[keyof typeof GoogleShoppingBiddingStrategy];

export const HealthCheckId = {
  GOOGLE_TEST_ACCOUNT: 'google.test_account',
  GOOGLE_ACCOUNT_STATUS: 'google.account_status',
  GOOGLE_CONVERSION_TRACKING: 'google.conversion_tracking',
  GOOGLE_AUTO_TAGGING: 'google.auto_tagging',
  GOOGLE_MERCHANT_CENTER: 'google.merchant_center',
  GOOGLE_CURRENCY_ALIGNMENT: 'google.currency_alignment',
  META_ACCOUNT_STATUS: 'meta.account_status',
  META_PAYMENT_METHOD: 'meta.payment_method',
  META_PIXEL_ACTIVITY: 'meta.pixel_activity',
  META_BUSINESS_VERIFICATION: 'meta.business_verification',
  META_PRODUCT_CATALOG: 'meta.product_catalog',
  META_CURRENCY_ALIGNMENT: 'meta.currency_alignment',
  META_LEAD_FORM_TOS_ACCEPTED: 'meta.lead_form_tos_accepted',
  META_CAPI_EVENT_MATCH_QUALITY: 'meta.capi_event_match_quality',
  META_NO_FACEBOOK_PAGE: 'meta.no_facebook_page',
  GTM_GA4_CONFIG: 'gtm.ga4_config',
  GTM_META_PIXEL: 'gtm.meta_pixel',
  GTM_CONVERSION_LINKER: 'gtm.conversion_linker',
  GTM_GOOGLE_ADS_CONVERSION: 'gtm.google_ads_conversion',
  GTM_GA4_EVENT_COVERAGE: 'gtm.ga4_event_coverage',
  GTM_CONSENT_MODE: 'gtm.consent_mode',
  GA4_GOAL_STREAM_SCOPE: 'ga4.goal_stream_scope',
  ASSET_APPROVAL_PENDING: 'asset_approval_pending',
  GOAL_PLATFORM_MAPPING: 'goal_platform_mapping',
  GOAL_PUSH_DRIFT: 'goal_push_drift',
  GOAL_CONFIG_UNREAD: 'goal_config_unread',
  STRATEGY_PRIMARY_GOAL_MISSING: 'strategy_primary_goal_missing',
} as const;
export type HealthCheckId = (typeof HealthCheckId)[keyof typeof HealthCheckId];

export const HealthCheckSeverity = {
  BLOCKER: 'blocker',
  WARNING: 'warning',
  INFO: 'info',
} as const;
export type HealthCheckSeverity =
  (typeof HealthCheckSeverity)[keyof typeof HealthCheckSeverity];

export const HealthCheckStatus = {
  PASS: 'pass',
  FAIL: 'fail',
  SKIP: 'skip',
  ERROR: 'error',
} as const;
export type HealthCheckStatus =
  (typeof HealthCheckStatus)[keyof typeof HealthCheckStatus];

export const ImportDepth = {
  METADATA: 'metadata',
  FULL_CONFIG: 'full_config',
} as const;
export type ImportDepth = (typeof ImportDepth)[keyof typeof ImportDepth];

export const IngestionNarration = {
  ONBOARDING_DATA_READY: 'onboarding_data_ready',
  PLATFORM_READY: 'platform_ready',
  HEALTH_CHECK_BLOCKER: 'health_check_blocker',
  HEALTH_CHECK_STARTED: 'health_check_started',
  HEALTH_CHECK_PASSED: 'health_check_passed',
  CAMPAIGN_IMPORT_STARTED: 'campaign_import_started',
  CAMPAIGN_IMPORT_COMPLETE: 'campaign_import_complete',
  GATE_WAITING: 'gate_waiting',
  PROFILE_SEEDING: 'profile_seeding',
} as const;
export type IngestionNarration =
  (typeof IngestionNarration)[keyof typeof IngestionNarration];

export const InsightSeverity = {
  INFO: 'info',
  WARNING: 'warning',
  CRITICAL: 'critical',
} as const;
export type InsightSeverity =
  (typeof InsightSeverity)[keyof typeof InsightSeverity];

export const InsightType = {
  PERFORMANCE_SHIFT: 'performance_shift',
  SPEND_ANOMALY: 'spend_anomaly',
  PACING_ALERT: 'pacing_alert',
  TREND: 'trend',
  OPPORTUNITY: 'opportunity',
  MONTHLY_DIGEST: 'monthly_digest',
} as const;
export type InsightType = (typeof InsightType)[keyof typeof InsightType];

export const IntakeNoticeSeverity = {
  INFO: 'info',
  BLOCKER: 'blocker',
} as const;
export type IntakeNoticeSeverity =
  (typeof IntakeNoticeSeverity)[keyof typeof IntakeNoticeSeverity];

export const IntentSignal = {
  META_OBJECTIVE_AWARENESS: 'META_OBJECTIVE_AWARENESS',
  META_OBJECTIVE_TRAFFIC: 'META_OBJECTIVE_TRAFFIC',
  META_OBJECTIVE_ENGAGEMENT: 'META_OBJECTIVE_ENGAGEMENT',
  META_OBJECTIVE_LEADS: 'META_OBJECTIVE_LEADS',
  META_OBJECTIVE_SALES: 'META_OBJECTIVE_SALES',
  META_GOAL_AWARENESS: 'META_GOAL_AWARENESS',
  META_GOAL_TRAFFIC: 'META_GOAL_TRAFFIC',
  META_GOAL_ENGAGEMENT: 'META_GOAL_ENGAGEMENT',
  META_GOAL_LEADS: 'META_GOAL_LEADS',
  META_GOAL_SALES: 'META_GOAL_SALES',
  WIZARD_OBJECTIVE_AWARENESS: 'WIZARD_OBJECTIVE_AWARENESS',
  WIZARD_OBJECTIVE_ENGAGEMENT: 'WIZARD_OBJECTIVE_ENGAGEMENT',
  WIZARD_OBJECTIVE_SALES: 'WIZARD_OBJECTIVE_SALES',
  GOOGLE_SHOPPING: 'GOOGLE_SHOPPING',
  GOOGLE_BID_AWARENESS: 'GOOGLE_BID_AWARENESS',
  GOOGLE_BID_TRAFFIC: 'GOOGLE_BID_TRAFFIC',
  GOOGLE_BID_SALES: 'GOOGLE_BID_SALES',
  GOOGLE_GOAL_LEADS: 'GOOGLE_GOAL_LEADS',
  GOOGLE_GOAL_SALES: 'GOOGLE_GOAL_SALES',
  GOOGLE_ACCOUNT_GOALS_LEADS: 'GOOGLE_ACCOUNT_GOALS_LEADS',
  GOOGLE_ACCOUNT_GOALS_SALES: 'GOOGLE_ACCOUNT_GOALS_SALES',
  NONE: 'NONE',
} as const;
export type IntentSignal = (typeof IntentSignal)[keyof typeof IntentSignal];

export const IntentSource = {
  PLATFORM: 'PLATFORM',
  ASSUMED: 'ASSUMED',
  USER: 'USER',
} as const;
export type IntentSource = (typeof IntentSource)[keyof typeof IntentSource];

export const InvitationStatus = {
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
} as const;
export type InvitationStatus =
  (typeof InvitationStatus)[keyof typeof InvitationStatus];

export const LLMFeature = {
  COPILOT: 'copilot',
  MEDIA_PLAN_GENERATION: 'media_plan_generation',
  CAMPAIGN_GENERATION: 'campaign_generation',
  CREATIVE_TEXT_GENERATION: 'creative_text_generation',
  COPILOT_COMMAND: 'copilot_command',
  FORECASTING: 'forecasting',
  AI_MONITOR: 'ai_monitor',
  DEFAULT_ASSET_RANKING: 'default_asset_ranking',
  EMBEDDING: 'embedding',
  IMAGE_GENERATION: 'image_generation',
} as const;
export type LLMFeature = (typeof LLMFeature)[keyof typeof LLMFeature];

export const Language = {
  ENGLISH: 'en',
  SPANISH: 'es',
  FRENCH: 'fr',
  GERMAN: 'de',
  ITALIAN: 'it',
  PORTUGUESE: 'pt',
  DUTCH: 'nl',
  RUSSIAN: 'ru',
  JAPANESE: 'ja',
  KOREAN: 'ko',
  CHINESE: 'zh',
  GREEK: 'el',
} as const;
export type Language = (typeof Language)[keyof typeof Language];

export const LeadConversionLocation = {
  INSTANT_FORM: 'INSTANT_FORM',
  PHONE_CALL: 'PHONE_CALL',
  MESSENGER: 'MESSENGER',
  WEBSITE: 'WEBSITE',
} as const;
export type LeadConversionLocation =
  (typeof LeadConversionLocation)[keyof typeof LeadConversionLocation];

export const LeadFormCtaButtonType = {
  VIEW_WEBSITE: 'VIEW_WEBSITE',
  DOWNLOAD: 'DOWNLOAD',
  CALL_BUSINESS: 'CALL_BUSINESS',
  MESSAGE_BUSINESS: 'MESSAGE_BUSINESS',
  VIEW_ON_FACEBOOK: 'VIEW_ON_FACEBOOK',
  NONE: 'NONE',
} as const;
export type LeadFormCtaButtonType =
  (typeof LeadFormCtaButtonType)[keyof typeof LeadFormCtaButtonType];

export const LeadFormQuestionFormat = {
  SHORT_TEXT: 'SHORT_TEXT',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  DROPDOWN: 'DROPDOWN',
  CONDITIONAL: 'CONDITIONAL',
} as const;
export type LeadFormQuestionFormat =
  (typeof LeadFormQuestionFormat)[keyof typeof LeadFormQuestionFormat];

export const LeadFormQuestionType = {
  FULL_NAME: 'FULL_NAME',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  EMAIL: 'EMAIL',
  WORK_EMAIL: 'WORK_EMAIL',
  PHONE: 'PHONE',
  WORK_PHONE_NUMBER: 'WORK_PHONE_NUMBER',
  STREET_ADDRESS: 'STREET_ADDRESS',
  CITY: 'CITY',
  STATE: 'STATE',
  PROVINCE: 'PROVINCE',
  COUNTRY: 'COUNTRY',
  ZIP: 'ZIP',
  DOB: 'DOB',
  GENDER: 'GENDER',
  JOB_TITLE: 'JOB_TITLE',
  COMPANY_NAME: 'COMPANY_NAME',
  CUSTOM: 'CUSTOM',
} as const;
export type LeadFormQuestionType =
  (typeof LeadFormQuestionType)[keyof typeof LeadFormQuestionType];

export const LeadFormType = {
  MORE_VOLUME: 'MORE_VOLUME',
  HIGHER_INTENT: 'HIGHER_INTENT',
} as const;
export type LeadFormType = (typeof LeadFormType)[keyof typeof LeadFormType];

export const LearningCategory = {
  RECOMMENDATION_FEEDBACK: 'recommendation_feedback',
  CAMPAIGN_OUTCOME: 'campaign_outcome',
  INSIGHT_FEEDBACK: 'insight_feedback',
} as const;
export type LearningCategory =
  (typeof LearningCategory)[keyof typeof LearningCategory];

export const ManagementRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
} as const;
export type ManagementRequestStatus =
  (typeof ManagementRequestStatus)[keyof typeof ManagementRequestStatus];

export const MatchType = {
  EXACT: 'exact',
  PHRASE: 'phrase',
  BROAD: 'broad',
} as const;
export type MatchType = (typeof MatchType)[keyof typeof MatchType];

export const MessageContextType = {
  STRATEGY: 'strategy',
  WIZARD: 'wizard',
  CAMPAIGN: 'campaign',
  REPORTS: 'reports',
  WORKSPACE: 'workspace',
  ASSET_LIBRARY: 'asset_library',
  AUDIENCE_LIBRARY: 'audience_library',
  GOAL_TRACKING: 'goal_tracking',
  PRODUCT_CATEGORY: 'product_category',
  RECOMMENDATION: 'recommendation',
} as const;
export type MessageContextType =
  (typeof MessageContextType)[keyof typeof MessageContextType];

export const MessageFeedback = {
  HELPFUL: 'HELPFUL',
  NOT_HELPFUL: 'NOT_HELPFUL',
} as const;
export type MessageFeedback =
  (typeof MessageFeedback)[keyof typeof MessageFeedback];

export const MessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant',
} as const;
export type MessageRole = (typeof MessageRole)[keyof typeof MessageRole];

export const MetaAudienceType = {
  CUSTOM: 'custom',
  LOOKALIKE: 'lookalike',
} as const;
export type MetaAudienceType =
  (typeof MetaAudienceType)[keyof typeof MetaAudienceType];

export const MetaAwarenessOptimizationGoal = {
  REACH: 'REACH',
  IMPRESSIONS: 'IMPRESSIONS',
  AD_RECALL_LIFT: 'AD_RECALL_LIFT',
} as const;
export type MetaAwarenessOptimizationGoal =
  (typeof MetaAwarenessOptimizationGoal)[keyof typeof MetaAwarenessOptimizationGoal];

export const MetaBidStrategy = {
  LOWEST_COST_WITHOUT_CAP: 'LOWEST_COST_WITHOUT_CAP',
  LOWEST_COST_WITH_BID_CAP: 'LOWEST_COST_WITH_BID_CAP',
  COST_CAP: 'COST_CAP',
  LOWEST_COST_WITH_MIN_ROAS: 'LOWEST_COST_WITH_MIN_ROAS',
} as const;
export type MetaBidStrategy =
  (typeof MetaBidStrategy)[keyof typeof MetaBidStrategy];

export const MetaCampaignType = {
  SHOPPING: 'SHOPPING',
  AWARENESS: 'AWARENESS',
  LEADS: 'LEADS',
  TRAFFIC: 'TRAFFIC',
  ENGAGEMENT: 'ENGAGEMENT',
} as const;
export type MetaCampaignType =
  (typeof MetaCampaignType)[keyof typeof MetaCampaignType];

export const MetaDestinationType = {
  WEBSITE: 'WEBSITE',
  APP: 'APP',
  ON_AD: 'ON_AD',
  MESSENGER: 'MESSENGER',
  INSTAGRAM_DIRECT: 'INSTAGRAM_DIRECT',
  WHATSAPP: 'WHATSAPP',
  PHONE_CALL: 'PHONE_CALL',
} as const;
export type MetaDestinationType =
  (typeof MetaDestinationType)[keyof typeof MetaDestinationType];

export const MetaEngagementDestinationType = {
  FEED: 'FEED',
  MESSENGER: 'MESSENGER',
  INSTAGRAM_DIRECT: 'INSTAGRAM_DIRECT',
  WHATSAPP: 'WHATSAPP',
} as const;
export type MetaEngagementDestinationType =
  (typeof MetaEngagementDestinationType)[keyof typeof MetaEngagementDestinationType];

export const MetaEngagementOptimizationGoal = {
  POST_ENGAGEMENT: 'POST_ENGAGEMENT',
  CONVERSATIONS: 'CONVERSATIONS',
} as const;
export type MetaEngagementOptimizationGoal =
  (typeof MetaEngagementOptimizationGoal)[keyof typeof MetaEngagementOptimizationGoal];

export const MetaFacebookPosition = {
  FEED: 'feed',
  MARKETPLACE: 'marketplace',
  STORY: 'story',
  FACEBOOK_REELS: 'facebook_reels',
} as const;
export type MetaFacebookPosition =
  (typeof MetaFacebookPosition)[keyof typeof MetaFacebookPosition];

export const MetaInstagramPosition = {
  STREAM: 'stream',
  STORY: 'story',
  EXPLORE: 'explore',
  REELS: 'reels',
  SHOP: 'shop',
} as const;
export type MetaInstagramPosition =
  (typeof MetaInstagramPosition)[keyof typeof MetaInstagramPosition];

export const MetaLeadsOptimizationGoal = {
  LEAD_GENERATION: 'LEAD_GENERATION',
  QUALITY_LEAD: 'QUALITY_LEAD',
  QUALITY_CALL: 'QUALITY_CALL',
  OFFSITE_CONVERSIONS: 'OFFSITE_CONVERSIONS',
  LINK_CLICKS: 'LINK_CLICKS',
  LANDING_PAGE_VIEWS: 'LANDING_PAGE_VIEWS',
  IMPRESSIONS: 'IMPRESSIONS',
  REACH: 'REACH',
} as const;
export type MetaLeadsOptimizationGoal =
  (typeof MetaLeadsOptimizationGoal)[keyof typeof MetaLeadsOptimizationGoal];

export const MetaLeadsPixelEvent = {
  LEAD: 'LEAD',
  COMPLETE_REGISTRATION: 'COMPLETE_REGISTRATION',
} as const;
export type MetaLeadsPixelEvent =
  (typeof MetaLeadsPixelEvent)[keyof typeof MetaLeadsPixelEvent];

export const MetaPublisherPlatform = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  AUDIENCE_NETWORK: 'audience_network',
  MESSENGER: 'messenger',
} as const;
export type MetaPublisherPlatform =
  (typeof MetaPublisherPlatform)[keyof typeof MetaPublisherPlatform];

export const MetaTrafficDestinationType = {
  WEBSITE: 'WEBSITE',
  APP: 'APP',
  MESSENGER: 'MESSENGER',
  WHATSAPP: 'WHATSAPP',
  PHONE_CALL: 'PHONE_CALL',
} as const;
export type MetaTrafficDestinationType =
  (typeof MetaTrafficDestinationType)[keyof typeof MetaTrafficDestinationType];

export const MetaTrafficOptimizationGoal = {
  LINK_CLICKS: 'LINK_CLICKS',
  LANDING_PAGE_VIEWS: 'LANDING_PAGE_VIEWS',
} as const;
export type MetaTrafficOptimizationGoal =
  (typeof MetaTrafficOptimizationGoal)[keyof typeof MetaTrafficOptimizationGoal];

export const MetricAggregation = {
  SUM: 'sum',
  DERIVED: 'derived',
} as const;
export type MetricAggregation =
  (typeof MetricAggregation)[keyof typeof MetricAggregation];

export const MetricId = {
  SPEND: 'spend',
  IMPRESSIONS: 'impressions',
  CLICKS: 'clicks',
  CONVERSIONS: 'conversions',
  CONVERSION_VALUE: 'conversion_value',
  REACH: 'reach',
  LANDING_PAGE_VIEWS: 'landing_page_views',
  LEADS: 'leads',
  PURCHASES: 'purchases',
  ROAS: 'roas',
  CPA: 'cpa',
  CPC: 'cpc',
  CTR: 'ctr',
  CPM: 'cpm',
  CPL: 'cpl',
  FREQUENCY: 'frequency',
  CONVERSION_RATE: 'conversion_rate',
  FORM_COMPLETION_RATE: 'form_completion_rate',
  POST_ENGAGEMENT: 'post_engagement',
  CONVERSATION_COUNT: 'conversation_count',
  POST_ENGAGEMENT_RATE: 'post_engagement_rate',
  COST_PER_ENGAGEMENT: 'cost_per_engagement',
  COST_PER_CONVERSATION: 'cost_per_conversation',
} as const;
export type MetricId = (typeof MetricId)[keyof typeof MetricId];

export const MetricLevel = {
  CAMPAIGN: 'campaign',
  AD_GROUP: 'ad_group',
  AD: 'ad',
  KEYWORD: 'keyword',
  SEARCH_TERM: 'search_term',
  CREATIVE: 'creative',
  PRODUCT_PARTITION: 'product_partition',
} as const;
export type MetricLevel = (typeof MetricLevel)[keyof typeof MetricLevel];

export const NegativeGeoTargetType = {
  PRESENCE: 'presence',
  PRESENCE_OR_INTEREST: 'presence_or_interest',
} as const;
export type NegativeGeoTargetType =
  (typeof NegativeGeoTargetType)[keyof typeof NegativeGeoTargetType];

export const NetworkType = {
  SEARCH_ONLY: 'search_only',
  SEARCH_AND_DISPLAY: 'search_and_display',
} as const;
export type NetworkType = (typeof NetworkType)[keyof typeof NetworkType];

export const NoTopClaimReason = {
  ONE_CAMPAIGN: 'ONE_CAMPAIGN',
  NO_RESULTS: 'NO_RESULTS',
  MIXED_CURRENCY: 'MIXED_CURRENCY',
  MIXED_COUNTING: 'MIXED_COUNTING',
} as const;
export type NoTopClaimReason =
  (typeof NoTopClaimReason)[keyof typeof NoTopClaimReason];

export const NotificationAudience = {
  ALL: 'ALL',
  ADMINS: 'ADMINS',
} as const;
export type NotificationAudience =
  (typeof NotificationAudience)[keyof typeof NotificationAudience];

export const NotificationLane = {
  ALERT: 'ALERT',
  ACTIVITY: 'ACTIVITY',
} as const;
export type NotificationLane =
  (typeof NotificationLane)[keyof typeof NotificationLane];

export const NotificationLinkType = {
  RECOMMENDATION: 'RECOMMENDATION',
  PLATFORM_CONNECTION: 'PLATFORM_CONNECTION',
  STRATEGY_CAMPAIGN: 'STRATEGY_CAMPAIGN',
  STRATEGY: 'STRATEGY',
  CAMPAIGN: 'CAMPAIGN',
  CONVERSION_GOAL: 'CONVERSION_GOAL',
  AGENCY_GRANT: 'AGENCY_GRANT',
  MANAGEMENT_REQUEST: 'MANAGEMENT_REQUEST',
} as const;
export type NotificationLinkType =
  (typeof NotificationLinkType)[keyof typeof NotificationLinkType];

export const NotificationType = {
  RECOMMENDATION: 'RECOMMENDATION',
  INTEGRATION_HEALTH: 'INTEGRATION_HEALTH',
  APPLY_RECEIPT: 'APPLY_RECEIPT',
  JOB_STATUS: 'JOB_STATUS',
  EXTERNAL_DRIFT: 'EXTERNAL_DRIFT',
  PERFORMANCE_ANOMALY: 'PERFORMANCE_ANOMALY',
  BILLING: 'BILLING',
  SUPPORT_REQUEST: 'SUPPORT_REQUEST',
  AGENCY_MANAGEMENT: 'AGENCY_MANAGEMENT',
} as const;
export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];

export const OrganizationKind = {
  ADVERTISER: 'ADVERTISER',
  AGENCY: 'AGENCY',
} as const;
export type OrganizationKind =
  (typeof OrganizationKind)[keyof typeof OrganizationKind];

export const OrganizationStatus = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
export type OrganizationStatus =
  (typeof OrganizationStatus)[keyof typeof OrganizationStatus];

export const PMaxBiddingFocus = {
  CONVERSIONS: 'conversions',
  CONVERSION_VALUE: 'conversion_value',
  TARGET_CPA: 'target_cpa',
  TARGET_ROAS: 'target_roas',
} as const;
export type PMaxBiddingFocus =
  (typeof PMaxBiddingFocus)[keyof typeof PMaxBiddingFocus];

export const PMaxCallToAction = {
  GET_SHOWTIMES: 'get_showtimes',
  LEARN_MORE: 'learn_more',
  LISTEN_NOW: 'listen_now',
  ORDER_NOW: 'order_now',
  PLAY_GAME: 'play_game',
  REQUEST_TIME: 'request_time',
  SEE_MENU: 'see_menu',
  SHOP_NOW: 'shop_now',
  SIGN_UP: 'sign_up',
  SUBSCRIBE: 'subscribe',
  WATCH_MORE: 'watch_more',
} as const;
export type PMaxCallToAction =
  (typeof PMaxCallToAction)[keyof typeof PMaxCallToAction];

export const PMaxListingDimension = {
  PRODUCT_BRAND: 'product_brand',
  PRODUCT_TYPE: 'product_type',
  PRODUCT_ITEM_ID: 'product_item_id',
  CUSTOM_LABEL_0: 'custom_label_0',
  CUSTOM_LABEL_1: 'custom_label_1',
  CUSTOM_LABEL_2: 'custom_label_2',
  CUSTOM_LABEL_3: 'custom_label_3',
  CUSTOM_LABEL_4: 'custom_label_4',
  PRODUCT_CHANNEL: 'product_channel',
  PRODUCT_CONDITION: 'product_condition',
} as const;
export type PMaxListingDimension =
  (typeof PMaxListingDimension)[keyof typeof PMaxListingDimension];

export const PacingPolicy = {
  STANDARD: 'STANDARD',
  ACCELERATED: 'ACCELERATED',
} as const;
export type PacingPolicy = (typeof PacingPolicy)[keyof typeof PacingPolicy];

export const PerformanceGoal = {
  MAXIMIZE_NUMBER_OF_CONVERSIONS: 'maximize_number_of_conversions',
  MAXIMIZE_VALUE_OF_CONVERSIONS: 'maximize_value_of_conversions',
  MAXIMIZE_NUMBER_OF_LANDING_PAGE_VIEWS:
    'maximize_number_of_landing_page_views',
  MAXIMIZE_NUMBER_OF_LINK_CLICKS: 'maximize_number_of_link_clicks',
  MAXIMIZE_DAILY_UNIQUE_REACH: 'maximize_daily_unique_reach',
  MAXIMIZE_NUMBER_OF_IMPRESSIONS: 'maximize_number_of_impressions',
} as const;
export type PerformanceGoal =
  (typeof PerformanceGoal)[keyof typeof PerformanceGoal];

export const PinRefusalReason = {
  OBJECTIVE_UNSUPPORTED: 'objective_unsupported',
  NOT_CONNECTED: 'not_connected',
  NEEDS_FACEBOOK_PAGE: 'needs_facebook_page',
  NOT_READY: 'not_ready',
  NEEDS_TRACKED_CONVERSIONS: 'needs_tracked_conversions',
} as const;
export type PinRefusalReason =
  (typeof PinRefusalReason)[keyof typeof PinRefusalReason];

export const PinnedField = {
  HEADLINE_1: 'HEADLINE_1',
  HEADLINE_2: 'HEADLINE_2',
  HEADLINE_3: 'HEADLINE_3',
  DESCRIPTION_1: 'DESCRIPTION_1',
  DESCRIPTION_2: 'DESCRIPTION_2',
} as const;
export type PinnedField = (typeof PinnedField)[keyof typeof PinnedField];

export const PlanSource = {
  TRIAL: 'TRIAL',
  STRIPE: 'STRIPE',
  MANUAL: 'MANUAL',
  AGENCY: 'AGENCY',
} as const;
export type PlanSource = (typeof PlanSource)[keyof typeof PlanSource];

export const PlanTier = {
  TRIAL: 'TRIAL',
  STARTER: 'STARTER',
  AGENCY: 'AGENCY',
  ENTERPRISE: 'ENTERPRISE',
} as const;
export type PlanTier = (typeof PlanTier)[keyof typeof PlanTier];

export const Platform = {
  GOOGLE: 'google',
  META: 'meta',
  AMAZON: 'amazon',
  TIKTOK: 'tiktok',
  SHOPIFY: 'shopify',
  GA4: 'ga4',
  GTM: 'gtm',
} as const;
export type Platform = (typeof Platform)[keyof typeof Platform];

export const PlatformAssetSyncStatus = {
  PENDING: 'pending',
  SYNCING: 'syncing',
  SYNCED: 'synced',
  PENDING_REVIEW: 'pending_review',
  REJECTED: 'rejected',
  FAILED: 'failed',
  INVALID: 'invalid',
} as const;
export type PlatformAssetSyncStatus =
  (typeof PlatformAssetSyncStatus)[keyof typeof PlatformAssetSyncStatus];

export const PlatformCampaignStatus = {
  ENABLED: 'ENABLED',
  PAUSED: 'PAUSED',
  REMOVED: 'REMOVED',
  UNKNOWN: 'UNKNOWN',
} as const;
export type PlatformCampaignStatus =
  (typeof PlatformCampaignStatus)[keyof typeof PlatformCampaignStatus];

export const PlatformCategory = {
  AD: 'ad',
  MEASUREMENT: 'measurement',
} as const;
export type PlatformCategory =
  (typeof PlatformCategory)[keyof typeof PlatformCategory];

export const PlatformConnectionStatus = {
  CONNECTED: 'CONNECTED',
  EXPIRED: 'EXPIRED',
} as const;
export type PlatformConnectionStatus =
  (typeof PlatformConnectionStatus)[keyof typeof PlatformConnectionStatus];

export const PortfolioClientHealth = {
  FAILING: 'FAILING',
  SETUP_NEEDED: 'SETUP_NEEDED',
  AT_RISK: 'AT_RISK',
  HEALTHY: 'HEALTHY',
} as const;
export type PortfolioClientHealth =
  (typeof PortfolioClientHealth)[keyof typeof PortfolioClientHealth];

export const PortfolioFilter = {
  NEEDS_ATTENTION: 'NEEDS_ATTENTION',
  ON_TRACK: 'ON_TRACK',
  SETUP_NEEDED: 'SETUP_NEEDED',
} as const;
export type PortfolioFilter =
  (typeof PortfolioFilter)[keyof typeof PortfolioFilter];

export const PortfolioKpiStatus = {
  ON_TARGET: 'ON_TARGET',
  OFF_TARGET: 'OFF_TARGET',
  NO_TARGET: 'NO_TARGET',
  NO_DATA: 'NO_DATA',
} as const;
export type PortfolioKpiStatus =
  (typeof PortfolioKpiStatus)[keyof typeof PortfolioKpiStatus];

export const PortfolioSortField = {
  NAME: 'NAME',
  SPEND: 'SPEND',
  SPEND_AT_STAKE: 'SPEND_AT_STAKE',
  HEALTH: 'HEALTH',
  OPEN_RECOMMENDATIONS: 'OPEN_RECOMMENDATIONS',
  PACING: 'PACING',
} as const;
export type PortfolioSortField =
  (typeof PortfolioSortField)[keyof typeof PortfolioSortField];

export const PositiveGeoTargetType = {
  PRESENCE_OR_INTEREST: 'presence_or_interest',
  PRESENCE: 'presence',
} as const;
export type PositiveGeoTargetType =
  (typeof PositiveGeoTargetType)[keyof typeof PositiveGeoTargetType];

export const ProductCategorySource = {
  FEED: 'FEED',
  MANUAL: 'MANUAL',
} as const;
export type ProductCategorySource =
  (typeof ProductCategorySource)[keyof typeof ProductCategorySource];

export const ProductChannel = {
  ONLINE: 'ONLINE',
  LOCAL: 'LOCAL',
} as const;
export type ProductChannel =
  (typeof ProductChannel)[keyof typeof ProductChannel];

export const ProductChannelExclusivity = {
  SINGLE_CHANNEL: 'SINGLE_CHANNEL',
  MULTI_CHANNEL: 'MULTI_CHANNEL',
} as const;
export type ProductChannelExclusivity =
  (typeof ProductChannelExclusivity)[keyof typeof ProductChannelExclusivity];

export const ProductCondition = {
  NEW: 'NEW',
  REFURBISHED: 'REFURBISHED',
  USED: 'USED',
} as const;
export type ProductCondition =
  (typeof ProductCondition)[keyof typeof ProductCondition];

export const ProductGroupDimension = {
  BRAND: 'brand',
  PRODUCT_TYPE: 'product_type',
  ITEM_ID: 'item_id',
  CUSTOM_LABEL_0: 'custom_label_0',
  CUSTOM_LABEL_1: 'custom_label_1',
  CUSTOM_LABEL_2: 'custom_label_2',
  CUSTOM_LABEL_3: 'custom_label_3',
  CUSTOM_LABEL_4: 'custom_label_4',
  CATEGORY: 'category',
  CONDITION: 'condition',
  CHANNEL: 'channel',
  CHANNEL_EXCLUSIVITY: 'channel_exclusivity',
} as const;
export type ProductGroupDimension =
  (typeof ProductGroupDimension)[keyof typeof ProductGroupDimension];

export const ProductTextToken = {
  NAME: '{{product.name}}',
  PRICE: '{{product.price}}',
} as const;
export type ProductTextToken =
  (typeof ProductTextToken)[keyof typeof ProductTextToken];

export const ProximityRadiusUnits = {
  MILES: 'miles',
  KILOMETERS: 'kilometers',
} as const;
export type ProximityRadiusUnits =
  (typeof ProximityRadiusUnits)[keyof typeof ProximityRadiusUnits];

export const ReadOnlyReason = {
  TRIAL_ENDED: 'TRIAL_ENDED',
  SUBSCRIPTION_CANCELED: 'SUBSCRIPTION_CANCELED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  ADMIN: 'ADMIN',
  AGENCY_RELEASED: 'AGENCY_RELEASED',
} as const;
export type ReadOnlyReason =
  (typeof ReadOnlyReason)[keyof typeof ReadOnlyReason];

export const RemediationActionId = {
  ENABLE_AUTO_TAGGING: 'enable_auto_tagging',
} as const;
export type RemediationActionId =
  (typeof RemediationActionId)[keyof typeof RemediationActionId];

export const ReportSegment = {
  NONE: 'none',
  DEVICE: 'device',
  GEO: 'geo',
  AGE: 'age',
  GENDER: 'gender',
  PLACEMENT: 'placement',
  HOUR: 'hour',
  WEEKDAY: 'weekday',
  BIDDING_STRATEGY: 'bidding_strategy',
} as const;
export type ReportSegment = (typeof ReportSegment)[keyof typeof ReportSegment];

export const SSEEvent = {
  CONNECTED: 'connected',
  PROGRESS: 'progress',
  ERROR: 'error',
  JOB_COMPLETED: 'job_completed',
  JOB_FAILED: 'job_failed',
} as const;
export type SSEEvent = (typeof SSEEvent)[keyof typeof SSEEvent];

export const SearchTermDecisionAction = {
  CONFIRM_NEGATIVE: 'confirm_negative',
  FLAG_FOR_REVIEW: 'flag_for_review',
} as const;
export type SearchTermDecisionAction =
  (typeof SearchTermDecisionAction)[keyof typeof SearchTermDecisionAction];

export const SocialProvider = {
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
} as const;
export type SocialProvider =
  (typeof SocialProvider)[keyof typeof SocialProvider];

export const StatusEntity = {
  AD: 'ad',
  KEYWORD: 'keyword',
} as const;
export type StatusEntity = (typeof StatusEntity)[keyof typeof StatusEntity];

export const StrategyCampaignStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  REJECTED: 'REJECTED',
  ERROR: 'ERROR',
  DELETED: 'DELETED',
} as const;
export type StrategyCampaignStatus =
  (typeof StrategyCampaignStatus)[keyof typeof StrategyCampaignStatus];

export const StrategyHealthStatus = {
  HEALTHY: 'HEALTHY',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL',
} as const;
export type StrategyHealthStatus =
  (typeof StrategyHealthStatus)[keyof typeof StrategyHealthStatus];

export const StrategyObjective = {
  REACH: 'REACH',
  BRAND_AWARENESS: 'BRAND_AWARENESS',
  CONSIDERATIONS: 'CONSIDERATIONS',
  SALES_CONVERSIONS: 'SALES_CONVERSIONS',
  LOYALTY: 'LOYALTY',
} as const;
export type StrategyObjective =
  (typeof StrategyObjective)[keyof typeof StrategyObjective];

export const StrategyStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  PARTIALLY_ACTIVE: 'PARTIALLY_ACTIVE',
  PAUSED: 'PAUSED',
  ARCHIVED: 'ARCHIVED',
  ERROR: 'ERROR',
} as const;
export type StrategyStatus =
  (typeof StrategyStatus)[keyof typeof StrategyStatus];

export const SyncErrorCategory = {
  RECONNECT_REQUIRED: 'RECONNECT_REQUIRED',
  PLATFORM_REFUSED: 'PLATFORM_REFUSED',
  PLATFORM_UNAVAILABLE: 'PLATFORM_UNAVAILABLE',
  INTERRUPTED: 'INTERRUPTED',
  OTHER: 'OTHER',
} as const;
export type SyncErrorCategory =
  (typeof SyncErrorCategory)[keyof typeof SyncErrorCategory];

export const TargetingBucket = {
  DEMOGRAPHICS: 'demographics',
  GEO: 'geo',
  AUDIENCE: 'audience',
  EXCLUSIONS: 'exclusions',
} as const;
export type TargetingBucket =
  (typeof TargetingBucket)[keyof typeof TargetingBucket];

export const ThreadNarration = {
  TITLE_UPDATED: 'thread_title_updated',
} as const;
export type ThreadNarration =
  (typeof ThreadNarration)[keyof typeof ThreadNarration];

export const ThreadStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  PINNED: 'PINNED',
} as const;
export type ThreadStatus = (typeof ThreadStatus)[keyof typeof ThreadStatus];

export const TimeGrain = {
  NONE: 'none',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const;
export type TimeGrain = (typeof TimeGrain)[keyof typeof TimeGrain];

export const TimeUnit = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  LIFETIME: 'LIFETIME',
} as const;
export type TimeUnit = (typeof TimeUnit)[keyof typeof TimeUnit];

export const TitleSource = {
  AUTO: 'AUTO',
  USER: 'USER',
} as const;
export type TitleSource = (typeof TitleSource)[keyof typeof TitleSource];

export const TopUpPack = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
} as const;
export type TopUpPack = (typeof TopUpPack)[keyof typeof TopUpPack];

export const TrendDirection = {
  UP: 'up',
  DOWN: 'down',
  FLAT: 'flat',
} as const;
export type TrendDirection =
  (typeof TrendDirection)[keyof typeof TrendDirection];

export const TrialExtensionKind = {
  CONNECT_BONUS: 'CONNECT_BONUS',
  EXTENSION_LINK: 'EXTENSION_LINK',
} as const;
export type TrialExtensionKind =
  (typeof TrialExtensionKind)[keyof typeof TrialExtensionKind];

export const TrustBasis = {
  VERIFIED: 'verified',
  CLAIMED: 'claimed',
} as const;
export type TrustBasis = (typeof TrustBasis)[keyof typeof TrustBasis];

export const UiLanguage = {
  ENGLISH: 'en',
  SPANISH: 'es',
  GREEK: 'el',
} as const;
export type UiLanguage = (typeof UiLanguage)[keyof typeof UiLanguage];

export const UserRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  STANDARD: 'STANDARD',
  VIEWER: 'VIEWER',
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const WizardStep = {
  BRIEF: 'brief',
  PLAN: 'plan',
  CAMPAIGNS: 'campaigns',
} as const;
export type WizardStep = (typeof WizardStep)[keyof typeof WizardStep];

export const WITHHELD_METRICS = {
  COMMERCE: [],
  LEAD_GEN: ['conversion_value', 'roas'],
} as const;

export const WEBSITE_LEADS_OPTIMIZATION_GOALS = [
  'IMPRESSIONS',
  'LANDING_PAGE_VIEWS',
  'LINK_CLICKS',
  'OFFSITE_CONVERSIONS',
  'REACH',
] as const;

export const META_LOCALE_LANGUAGES = ['el', 'en'] as const;

export const PUBLIC_UI_LANGUAGES = ['en', 'es', 'el'] as const;

export const COPILOT_PLAN_FIELDS = [
  'ad_format',
  'ad_status',
  'age_ranges',
  'attribution_window_kind',
  'audience_id',
  'bidding',
  'call_to_action',
  'conversion_url_rule',
  'country',
  'daily_budget',
  'descriptions',
  'exclude_signal_ids',
  'excluded_audience_id',
  'extensions',
  'final_url',
  'genders',
  'headlines',
  'include_signal_ids',
  'keyword_status',
  'keywords',
  'kind',
  'negative_keywords',
  'platform',
  'product_category',
  'product_filters',
  'product_groups',
  'publish_to',
  'ratio',
  'seed_audience_id',
  'shopping_settings',
  'signal_id',
  'signal_type',
  'status',
  'targeting',
] as const;
